import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use", "beta"];
// @ts-expect-error FIXME
import connectLogoImage from 'bender-url!../../../images/logo/connect-dot-com-logo.svg';
// @ts-expect-error FIXME
import connectBetaLogoImage from 'bender-url!../../../images/logo/connect-dot-com-beta-logo.svg';
// @ts-expect-error FIXME
import connectIconImage from 'bender-url!../../../images/logo/connect-dot-com-icon.svg';
// @ts-expect-error FIXME
import connectBetaIconImage from 'bender-url!../../../images/logo/connect-dot-com-beta-icon.svg';
import I18n from 'I18n';
import CUIImage from '../CUIImage/CUIImage';
import { jsx as _jsx } from "react/jsx-runtime";
const CUIConnectLogo = _ref => {
  let {
      use = 'full',
      beta = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  let logo = connectLogoImage;
  if (use === 'icon') {
    if (beta) {
      logo = connectBetaIconImage;
    } else {
      logo = connectIconImage;
    }
  } else if (beta) {
    logo = connectBetaLogoImage;
  }
  return /*#__PURE__*/_jsx(CUIImage, Object.assign({}, rest, {
    src: logo,
    alt: I18n.text('connect.logoAltText')
  }));
};
export default CUIConnectLogo;